import React from 'react';
import { useTranslation } from 'react-i18next';

export function isNonEmptyObject(obj) {
  return (
    obj &&
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    Object.keys(obj).length > 0
  );
}

export function isNonEmptyArray(arr) {
  return Array.isArray(arr) && arr.length > 0;
}

export function preventOrphans(text) {
  if (text != '' && text != null) {
    const words = text.split(' ');
    if (words.length < 2) return text; // If the string has fewer than two words, return it as is

    const lastTwoWords = words.slice(-2).join(' ');
    const restOfText = words.slice(0, -2).join(' ');

    return (
      <>
        {restOfText}{' '}
        <span style={{ whiteSpace: 'nowrap' }}>{lastTwoWords}</span>
      </>
    );
  } else {
    return text;
  }
}

export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const fakeDomains = [
    'example.com',
    'test.com',
    'fake.com',
    'email.com',
    'mailinator.com',
    'yopmail.com',
  ];

  if (!emailRegex.test(email)) {
    return false; // Fails basic email format validation
  }

  const domain = email.split('@')[1].toLowerCase(); // Extract domain from email
  if (fakeDomains.includes(domain)) {
    return false; // Blacklist check for fake domains
  }

  return true; // Passes both regex and blacklist checks
}

export function isValidTextInput(input, options = {}) {
  const { minLength = 1, maxLength = 100, disallowedPatterns = [] } = options;

  // Ensure input is a string and trim whitespace
  if (typeof input !== 'string' || input.trim().length === 0) {
    return false; // Invalid if not a string or empty after trimming
  }

  const trimmedInput = input.trim();

  // Check length constraints
  if (trimmedInput.length < minLength || trimmedInput.length > maxLength) {
    return false; // Invalid if not within length constraints
  }

  if (disallowedPatterns.length > 0) {
    // Check for disallowed patterns
    for (const pattern of disallowedPatterns) {
      if (pattern.test(trimmedInput)) {
        return false; // Invalid if any disallowed pattern is matched
      }
    }
  }

  return true; // Passes all checks
}

export function reformatPhoneNumber(countryCode, phoneNumber) {
  if (!phoneNumber) return `+${countryCode}`;

  // usuń wszystkie znaki oprócz cyfr
  let clean = phoneNumber.replace(/\D/g, '');

  // usuń wiodące zero (np. 048 → 48, 0048 → 48)
  clean = clean.replace(/^0+/, '');

  // jeśli użytkownik już podał country code (np. +48...), usuń je
  if (clean.startsWith(countryCode)) {
    clean = clean.slice(countryCode.length);
  }

  return `+${countryCode}${clean}`;
}

export function formatTranslationNode(key, values = []) {
  const { t } = useTranslation();
  let str = t(key);

  // Split by <br /> for line breaks
  const parts = str.split(/<br\s*\/?>/i);

  return parts.map((part, i) => {
    let elements = [part];

    values.forEach((val, idx) => {
      elements = elements.flatMap((el) => {
        if (typeof el === 'string') {
          const split = el.split(`{${idx}}`);
          return split.reduce((acc, chunk, index) => {
            if (index === split.length - 1) return acc.concat(chunk);
            return acc.concat(chunk, val); // insert the JSX element
          }, []);
        }
        return el;
      });
    });

    return (
      <React.Fragment key={i}>
        {elements}
        {i < parts.length - 1 && <br />}
      </React.Fragment>
    );
  });
}
